window.onload = function() {
    const container = document.querySelector('.environment-container');
    if (container) {
        const scrollAmount = (container.scrollWidth - container.clientWidth) / 2;
        container.scrollTo({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
};
if(Shopify.designMode){
  mainFunc();
  only1Section();
document.addEventListener('shopify:section:load', function(event){
  mainFunc();
  only1Section();
});
}
else{
    
  mainFunc();

  const sections = document.querySelectorAll('[data-section-type="interactive-environment"]');
  sections.forEach((section, index) => {
    if (index > 0) {
      section.style.display = 'none';
    }
  });
  
}


function only1Section(){
  const sections = document.querySelectorAll('[data-section-type="interactive-environment"]');
  if (sections.length > 1) {
    alert("You can only have one interactive environment section on a page");
  sections.forEach((section, index) => {
    if (index > 0) {
      section.style.display = 'none';
    }
  });
}}

function mainFunc(event){                          
    function setRealVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  setRealVh();
  window.addEventListener('resize', setRealVh);
  window.addEventListener('orientationchange', setRealVh);
var U = 16/9;

function updateDimensions() {
    const container = document.querySelector('.environment-container');
    if (container) {
        const scrollAmount = (container.scrollWidth - container.clientWidth) / 2;
        container.scrollTo({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
  
    var width, height;
    if (window.innerWidth / window.innerHeight < U) {
        height = window.innerHeight;
        width = window.innerHeight * U;
    } else {
        width = window.innerWidth;
        height = window.innerWidth / U;
    }
    var element = document.getElementById('store-envrioment-img');
    if (element) {
        element.style.width = width + 'px';
        element.style.height = height + 'px';
    }
  
    positionLogo();
    positionSwipeGesture();
}
window.addEventListener('resize', updateDimensions);
updateDimensions();

const ipReferenceElements = document.querySelectorAll('.ip-reference');
const points = [];
let idCounter = 1;
ipReferenceElements.forEach(element => {
  const legacyIpData = element.getAttribute('ip-data');
  let ipData;

  const productJson = element.querySelector('.interactive-point-product-json');

  if (legacyIpData) {
    ipData = JSON.parse(legacyIpData);
    ipData.product = productJson ? JSON.parse(productJson.textContent) : null;
  } else {
    ipData = {
      description: element.dataset.description || '',
      x: element.dataset.x || '50',
      y: element.dataset.y || '50',
      link: element.dataset.link || '',
      dialogBoxColor: element.dataset.dialogBoxColor || '#ffffff',
      dialogWordColor: element.dataset.dialogWordColor || '#000000',
      ipColor: element.dataset.ipColor || '#ffffff',
      pulseRingColor: element.dataset.pulseRingColor || '#ffffff',
      product: productJson ? JSON.parse(productJson.textContent) : null
    };
  }

  ipData.id = idCounter;
  idCounter += 1;
  points.push(ipData);
    });

function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function(character) {
        return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '\'': '&#39;',
            '"': '&quot;'
        }[character];
    });
}

function renderDrawerRichText(htmlValue, plainValue, fallbackText) {
    const html = String(htmlValue || '').trim();
    if (html) return html;

    const text = String(plainValue || fallbackText || '').trim();
    if (!text) return '';

    return `<p>${escapeHtml(text).replace(/\n/g, '<br>')}</p>`;
}


function slugifyNotificationValue(value) {
    return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'product';
}

function getNotificationChannel() {
    const checked = document.querySelector('[data-high-thread-notify-channel]:checked');
    return checked ? checked.value : 'email';
}

/* The error slot is rendered unconditionally by the section and owned from here. It used
   to be wrapped in a form.errors conditional, so only a server round-trip could create it
   and nothing
   could remove it -- which is why the client saw "Email can't be blank." sitting in a
   freshly opened modal, and still sitting there after switching to WhatsApp. */
function getHighThreadNotificationErrorSlot() {
    const modal = document.getElementById('high-thread-notification-modal');
    return modal ? modal.querySelector('[data-high-thread-notify-error]') : null;
}

function clearHighThreadNotificationError() {
    const errorEl = getHighThreadNotificationErrorSlot();
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
}

function showHighThreadNotificationError(message) {
    const errorEl = getHighThreadNotificationErrorSlot();
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
}

/* WhatsApp restock requests go to Klaviyo, not to Shopify.
   -------------------------------------------------------
   The email channel still posts to Shopify's customer form, on the client's instruction
   ("we can leave the back in stock thing going to the shopify customers for now"). That
   form REQUIRES an email, so a WhatsApp-only request cannot use it -- which is the whole
   bug: selecting WhatsApp disables contact[email], Shopify rejects the POST, and the
   browser is navigated to the landing page with the number lost.

   KEEP IN SYNC WITH assets/high-thread-whatsapp-prompt.js, which is the canonical
   implementation of this call. Three things there are load-bearing and are repeated here
   for the same reasons, documented at length in that file:
     - revision is pinned to 2025-07-15; 2024-10-15 and earlier reject this payload.
     - the channel is `sms`, NOT `whatsapp`. High Thread has not enabled Klaviyo's
       WhatsApp channel and asking for whatsapp consent returns HTTP 400 every time. The
       consent line in the markup names SMS for exactly this reason.
     - no synthetic email address. The phone number is the only identifier needed, and a
       fabricated address is precisely what the client objected to seeing in Shopify.

   NOTE FOR THE CLIENT, NOT A CODE ISSUE: this uses the same list as the number-capture
   prompt, because that is the only list configured. A restock request is a different
   intent and probably wants its own list -- custom_source below keeps them separable in
   the meantime. */
/* Both channels of the restock form subscribe through here; only the destination and the
   identifier differ.

   THE TWO LISTS ARE DELIBERATELY SEPARATE and are not interchangeable. A phone number goes
   to the SMS list; an email address goes to the restock email list, which is a different
   audience the client works differently. Putting either in the other's list is the defect
   this function exists to prevent, so the list is chosen from the channel here rather than
   passed in by the caller. */
function highThreadPushRestockToKlaviyo(channel, identifier, title, sizeLabel) {
    const isEmail = channel === 'email';
    const publicKey = String("WnPmn2" || '').trim();
    const listId = isEmail
        ? String("V4KfPJ" || '').trim()
        : String("Scx9pk" || '').trim();

    if (!publicKey || !listId) {
        console.error('[high-thread] Klaviyo: public key or ' + channel + ' list id missing -- the restock request has nowhere to go.');
        return Promise.reject(new Error('Sign-ups aren’t available right now. Please try again later.'));
    }
    if (typeof window.fetch !== 'function') {
        return Promise.reject(new Error('Your browser can’t complete this sign-up. Please try a different browser.'));
    }

    /* One identifier only, matching the channel. Klaviyo treats both `email` and
       `phone_number` as real, marketable identities, so sending a placeholder in the unused
       one would make the profile look contactable on a channel nobody consented to. */
    const profileAttributes = isEmail
        ? {
            email: identifier,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        }
        : {
            phone_number: identifier,
            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
        };

    // So the client can see what the shopper is waiting on without cross-referencing.
    profileAttributes.properties = {
        restock_product: title || '',
        restock_size: sizeLabel || ''
    };

    const body = {
        data: {
            type: 'subscription',
            attributes: {
                custom_source: isEmail ? 'high_thread_restock_email' : 'high_thread_restock_whatsapp',
                profile: {
                    data: {
                        type: 'profile',
                        attributes: profileAttributes
                    }
                }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
        }
    };

    return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify(body),
        keepalive: true
    }).then(function(response) {
        if (response.ok) return undefined;
        return response.text().then(function(text) {
            console.error('[high-thread] Klaviyo: restock subscription not accepted (' + response.status + ').', text);
            throw new Error(isEmail
                ? 'We couldn’t save that email address. Please check it and try again.'
                : 'We couldn’t save that number. Please check it and try again.');
        });
    }, function(networkError) {
        // Second argument rather than a trailing .catch on purpose: this must catch only
        // fetch's own rejection and must not swallow the error thrown just above.
        console.error('[high-thread] Klaviyo: restock subscription request failed.', networkError);
        throw new Error('We couldn’t reach the sign-up service. Check your connection and try again.');
    });
}

/* Length alone cannot tell +44 from +1 -- both national numbers are 10 digits -- which is
   how a US number was previously stored as +443234232037. The dial code is therefore read
   from its own field rather than guessed. */
function getHighThreadNotificationPhoneE164() {
    const modal = document.getElementById('high-thread-notification-modal');
    if (!modal) return null;
    const codeInput = modal.querySelector('[data-high-thread-notify-code]');
    const phoneInput = modal.querySelector('[data-high-thread-notify-phone]');
    if (!phoneInput) return null;

    const dialDigits = String(codeInput ? codeInput.value : '+44').replace(/\D/g, '');
    const nationalDigits = String(phoneInput.value || '').replace(/\D/g, '').replace(/^0+/, '');

    if (!dialDigits) return { error: 'Please enter a country code, for example +44.' };
    if (nationalDigits.length < 6) return { error: 'Please enter your full mobile number.' };
    if ((dialDigits + nationalDigits).length > 15) return { error: 'That number looks too long — please check it.' };

    return { e164: '+' + dialDigits + nationalDigits };
}

/* Item 15: the size list is one radio group per product option, so a set no longer
   offers 25 radios all reading "8 / 10". No single radio identifies a combination any
   more, so the label is stitched back together from every group and the variant id comes
   from the lookup buildHighThreadNotificationSizes stamped on the modal.
   A single-option product still produces exactly what it produced before -- one group,
   no name prefix, label "8" -- because data-option-name is only set on sets. */
function getNotificationSizeSelection() {
    const modal = document.getElementById('high-thread-notification-modal');
    const checked = Array.prototype.slice.call(document.querySelectorAll('[data-high-thread-notify-size]:checked'));
    if (!checked.length) return { label: '', variantId: '' };

    const values = [];
    const labelParts = checked.map(function(input) {
        const optionIndex = Number(input.dataset.optionIndex || 0);
        values[optionIndex] = input.value || '';
        const optionName = input.dataset.optionName || '';
        return optionName ? optionName + ' ' + input.value : input.value;
    });

    let variantId = '';
    if (modal && modal.dataset.notifySizeIndex) {
        try {
            const index = JSON.parse(modal.dataset.notifySizeIndex);
            variantId = index[JSON.stringify(values)] || '';
        } catch (error) {
            console.error('[high-thread] Set Notifications: could not read the size lookup.', error);
        }
    }

    return { label: labelParts.join(' / '), variantId: String(variantId || '') };
}

/* Kept as a no-op-safe stub rather than deleted, because three call sites still invoke it
   and one of them is in sections/high-thread-mobile-home.liquid.

   Everything it used to do has moved. It wrote contact[tags] and contact[note] -- the
   product, size, channel and URL, encoded as a tag string and a prose note -- into hidden
   inputs, so that a Shopify customer record would carry them. This modal no longer creates
   a Shopify customer at all ("its not necessary to save in Shopify customers anymore"), and
   the same facts now go to Klaviyo as profile `properties` on the subscription, where they
   are queryable rather than being prose someone has to read.

   Do not restore the tag/note writing without restoring the inputs; they are gone from the
   markup, so the old body would have silently written to nothing. */
function syncHighThreadNotificationInputs() {
    /* Intentionally empty. See above. */
}

/* `preselection` is either a variant id (what the mobile homepage passes) or an array of
   option values (what the drawer passes when the shopper only got part way through a
   set). Both are normalised to option values here. */
function buildHighThreadNotificationSizes(product, preselection) {
    const modal = document.getElementById('high-thread-notification-modal');
    if (!modal || !product) return;

    const wrap = modal.querySelector('[data-high-thread-notify-size-wrap]');
    const options = modal.querySelector('[data-high-thread-notify-size-options]');
    if (!wrap || !options) return;

    const api = getInteractiveVariantOptionsApi();
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const sizeVariants = variants.filter(function(variant) {
        return variant && variant.title && variant.title !== 'Default Title';
    });
    const productOptions = api ? api.options(product) : [];

    if (!sizeVariants.length || !productOptions.length) {
        wrap.hidden = true;
        options.innerHTML = '';
        modal.dataset.notifySizeIndex = '{}';
        return;
    }

    const selected = api.toValues(product, preselection);
    // Combination -> variant id, so getNotificationSizeSelection can still report the one
    // variant the shopper is waiting on even though no single radio carries it.
    const sizeIndex = {};
    variants.forEach(function(variant) {
        sizeIndex[JSON.stringify(api.variantValues(variant))] = variant.id;
    });
    modal.dataset.notifySizeIndex = JSON.stringify(sizeIndex);

    // A product with one option keeps exactly the flat row it had before Item 15: the
    // per-option heading and the name prefix only appear when there is something to
    // disambiguate.
    const showOptionNames = productOptions.length > 1;

    wrap.hidden = false;
    options.innerHTML = productOptions.map(function(productOption, optionIndex) {
        const optionName = api.heading(productOption.name);
        /* The fieldset's own <legend> now sits above N groups rather than one, and each
           radio's name is a bare value ("8"), so without a group name a set reads out as
           two identical runs of radios. role="radiogroup" + aria-label puts the option
           name back on the group -- the same treatment The Find uses on its option rows.
           Only on a set: a single-option product has no heading to give, and its one
           group is already named by the legend. */
        return `
            <div class="high-thread-notification-modal__size-group" data-high-thread-notify-size-group${showOptionNames ? ` role="radiogroup" aria-label="${escapeHtml(optionName)}"` : ''}>
                ${showOptionNames ? `<span class="high-thread-notification-modal__size-heading" aria-hidden="true">${escapeHtml(optionName)}</span>` : ''}
                ${productOption.values.map(function(value, valueIndex) {
                    const id = 'HighThreadNotifySize-' + optionIndex + '-' + valueIndex;
                    const isSelected = selected[optionIndex] === value;
                    return `
                    <label class="high-thread-notification-modal__size-option${isSelected ? ' is-active' : ''}" for="${id}">
                        <input id="${id}" type="radio" data-custom-control name="notification_size_${optionIndex}" value="${escapeHtml(value)}" data-option-index="${optionIndex}"${showOptionNames ? ` data-option-name="${escapeHtml(optionName)}"` : ''} data-high-thread-notify-size ${valueIndex === 0 ? 'required' : ''} ${isSelected ? 'checked' : ''}>
                        <span>${escapeHtml(value)}</span>
                    </label>
                    `;
                }).join('')}
            </div>
        `;
    }).join('');

    options.querySelectorAll('[data-high-thread-notify-size]').forEach(function(input) {
        input.addEventListener('change', function() {
            options.querySelectorAll('.high-thread-notification-modal__size-option').forEach(function(option) {
                const optionInput = option.querySelector('[data-high-thread-notify-size]');
                option.classList.toggle('is-active', Boolean(optionInput && optionInput.checked));
            });
            syncHighThreadNotificationInputs();
        });
    });
}

function updateNotificationChannelFields() {
    // The error belongs to the channel that produced it. Switching to WhatsApp must not
    // leave "Email can't be blank." standing over a form that no longer has an email in it.
    clearHighThreadNotificationError();
    const channel = getNotificationChannel();
    document.querySelectorAll('[data-high-thread-notify-channel-option]').forEach(function(option) {
        const input = option.querySelector('[data-high-thread-notify-channel]');
        option.classList.toggle('is-active', Boolean(input && input.checked));
    });
    const emailField = document.querySelector('[data-high-thread-notify-email-field]');
    const phoneField = document.querySelector('[data-high-thread-notify-phone-field]');
    const emailInput = document.querySelector('[data-high-thread-notify-email]');
    const phoneInput = document.querySelector('[data-high-thread-notify-phone]');
    const consent = document.querySelector('[data-high-thread-notify-consent]');

    if (emailField && emailInput) {
        const showEmail = channel === 'email';
        emailField.hidden = !showEmail;
        emailField.setAttribute('aria-hidden', String(!showEmail));
        emailInput.required = showEmail;
        emailInput.disabled = !showEmail;
        if (!showEmail) emailInput.value = '';
    }

    if (phoneField && phoneInput) {
        const showPhone = channel === 'whatsapp';
        phoneField.hidden = !showPhone;
        phoneField.setAttribute('aria-hidden', String(!showPhone));
        phoneInput.required = showPhone;
        phoneInput.disabled = !showPhone;
        if (!showPhone) phoneInput.value = '';
    }

    if (consent) {
        /* Names SMS as well as WhatsApp, and that is not padding: the subscription is
           recorded on Klaviyo's `sms` channel because High Thread has not enabled the
           WhatsApp channel, and asking for whatsapp consent returns HTTP 400 every time.
           Consent has to describe the channel we actually send on. This line overrides
           whatever the section rendered, so the wording lives in both places -- keep them
           the same as the number-capture modal's. */
        consent.textContent = channel === 'whatsapp'
            ? 'I opt in to receive SMS and WhatsApp availability updates for this product.'
            : 'I opt in to receive email availability updates for this product.';
    }

    syncHighThreadNotificationInputs();
}

function openHighThreadNotificationModal(product, preselection) {
    const modal = document.getElementById('high-thread-notification-modal');
    const form = document.getElementById('HighThreadNotificationForm');
    if (!modal || !form || !product) return;

    const title = product.title || 'this piece';
    const handle = product.handle || slugifyNotificationValue(title);
    const productUrl = product.url || window.location.pathname;
    const copy = modal.querySelector('[data-high-thread-notify-product-copy]');
    const productTitle = modal.querySelector('[data-high-thread-notify-product-title]');
    const modalTitle = modal.querySelector('#high-thread-notification-title');
    const consentCheckbox = modal.querySelector('[data-high-thread-notify-consent-checkbox]');

    modal.dataset.productHandle = handle;
    modal.dataset.productTitle = title;
    modal.dataset.productUrl = productUrl;

    if (modalTitle) {
        modalTitle.textContent = 'Set Notifications';
    }

    if (copy) {
        copy.textContent = 'Choose a size and how you want to hear when this piece is available again.';
    }

    if (productTitle) {
        productTitle.hidden = false;
        productTitle.textContent = title;
    }

    buildHighThreadNotificationSizes(product, preselection);

    if (consentCheckbox) {
        consentCheckbox.checked = false;
    }

    /* Open clean, unconditionally. The carry-over that used to live here -- re-showing a
       server-seeded error for exactly one open -- went with the Shopify form: nothing can
       seed this slot from the server any more, so every message in it now comes from the
       submit handler and belongs to the attempt the shopper just made. */
    clearHighThreadNotificationError();
    const successEl = modal.querySelector('[data-high-thread-notify-success]');
    if (successEl) successEl.hidden = true;
    modal.classList.remove('is-success');
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('high-thread-notification-modal-open');
    updateNotificationChannelFields();
    syncHighThreadNotificationInputs();

    window.setTimeout(function() {
        const firstField = modal.querySelector('[data-high-thread-notify-size], input:not([type="hidden"]):not([hidden])');
        if (firstField) firstField.focus();
    }, 50);
}

function closeHighThreadNotificationModal() {
    const modal = document.getElementById('high-thread-notification-modal');
    if (!modal) return;
    modal.classList.remove('open', 'is-success');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('high-thread-notification-modal-open');
}

/* Every function in this file is declared inside mainFunc(), so none of them are
   global. The desktop drawer calls openHighThreadNotificationModal() by name from
   the same scope and works; the mobile homepage is a separate <script> in
   sections/high-thread-mobile-home.liquid and can only reach it through window,
   where it was undefined. Its handler therefore always fell into its
   "modal script not loaded" branch and the Set Notifications button did nothing —
   which is exactly the desktop-works/mobile-dead split the client reported.
   These exports are what make the mobile button work. Do not remove them. */
window.openHighThreadNotificationModal = openHighThreadNotificationModal;
window.closeHighThreadNotificationModal = closeHighThreadNotificationModal;

function openHighThreadNotificationSuccessModal() {
    const modal = document.getElementById('high-thread-notification-modal');
    if (!modal) return;

    const title = modal.querySelector('#high-thread-notification-title');
    const copy = modal.querySelector('[data-high-thread-notify-product-copy]');
    const productTitleEl = modal.querySelector('[data-high-thread-notify-product-title]');
    let productTitle = '';
    let productSize = '';

    try {
        productTitle = window.sessionStorage.getItem('highThreadNotifyProductTitle') || '';
        productSize = window.sessionStorage.getItem('highThreadNotifyProductSize') || '';
        window.sessionStorage.removeItem('highThreadNotifyProductTitle');
        window.sessionStorage.removeItem('highThreadNotifyProductSize');
        window.sessionStorage.removeItem('highThreadNotifySubmitted');
    } catch (error) {}

    // The success paragraph is rendered hidden on every load and unhidden here. It used to
    // exist only when Shopify had redirected back with posted_successfully?, which meant
    // the in-place WhatsApp confirmation had nothing to show.
    const successEl = modal.querySelector('[data-high-thread-notify-success]');
    if (successEl) successEl.hidden = false;
    clearHighThreadNotificationError();

    if (title) title.textContent = 'Notification Saved';
    if (productTitleEl) {
        productTitleEl.hidden = !productTitle;
        productTitleEl.textContent = productTitle;
    }
    if (copy) {
        const sizeText = productSize ? ' in size ' + productSize : '';
        copy.textContent = productTitle
            ? 'You’re on the list for ' + productTitle + sizeText + '. We’ll use your selected notification method when it becomes available.'
            : 'You’re on the notification list. We’ll use your selected notification method when this piece becomes available.';
    }

    modal.classList.add('open', 'is-success');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('high-thread-notification-modal-open');
}

function syncInteractiveDrawerState() {
    const productDrawer = document.getElementById('interactive-product-drawer');
    const cartDrawer = document.getElementById('cart-drawer');
    const productOpen = productDrawer && productDrawer.classList.contains('open');
    const cartOpen = cartDrawer && cartDrawer.classList.contains('open');

    document.body.classList.toggle('interactive-product-drawer-open', Boolean(productOpen));
    document.body.classList.toggle('interactive-cart-drawer-open', Boolean(cartOpen));
    document.body.classList.toggle('interactive-drawer-split-open', Boolean(productOpen && cartOpen));
}

function closeInteractiveProductDrawer() {
    const drawer = document.getElementById('interactive-product-drawer');
    const overlay = document.getElementById('interactive-product-drawer-overlay');
    if (!drawer || !overlay) return;

    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('.interactive-point.is-active-hotspot').forEach(function(el) {
        el.classList.remove('is-active-hotspot');
    });
    syncInteractiveDrawerState();
}

function closeHighThreadDrawers() {
    closeInteractiveProductDrawer();
    if (typeof window.closeCartDrawer === 'function') {
        window.closeCartDrawer();
    } else {
        document.getElementById('cart-drawer')?.classList.remove('open');
        document.getElementById('cart-drawer-overlay')?.classList.remove('active');
        syncInteractiveDrawerState();
    }
}

function openCartBesideInteractiveProductDrawer() {
    if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
    } else {
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.querySelector('.cart-text')?.click();
    }

    window.setTimeout(syncInteractiveDrawerState, 80);
}

function buildMeasurementFields(product) {
    if (!product || !product.requiresMeasurements) return '';

    const fields = [
        { key: 'Height', label: 'Height' },
        { key: 'Bust', label: 'Bust' },
        { key: 'Waist', label: 'Waist' },
        { key: 'Hip', label: 'Hip' }
    ];

    return `
        <div class="interactive-product-drawer__measurements" data-interactive-measurements>
            <p class="interactive-product-drawer__measurement-note">Please enter measurements:</p>
            <div class="interactive-product-drawer__measurement-grid">
                ${fields.map(function(field) {
                    return `
                        <label class="interactive-product-drawer__measurement-field">
                            <span>${escapeHtml(field.label)}</span>
                            <input type="text" inputmode="decimal" autocomplete="off" data-measurement-key="${escapeHtml(field.key)}" aria-label="${escapeHtml(field.label)} measurement" required>
                        </label>
                    `;
                }).join('')}
            </div>
        </div>
    `;
}

function buildInteractiveProductMedia(product, title) {
    const images = product && Array.isArray(product.images) && product.images.length
        ? product.images
        : (product && product.featuredImage ? [product.featuredImage] : []);

    if (!images.length) {
        return `<div class="interactive-product-drawer__image interactive-product-drawer__image--empty"></div>`;
    }

    return images.map(function(imageUrl, index) {
        return `<img class="interactive-product-drawer__image" src="${imageUrl}" alt="${escapeHtml(title)}${images.length > 1 ? ` ${index + 1}` : ''}">`;
    }).join('');
}

/* Client correction #6: a sold-out size must be selectable while other sizes are
   in stock, and picking it must flip the CTA to "Sold out — Set Notifications".
   This is the single place that decides which mode the button is in, so the
   initial render and every later update agree. */
function getInteractiveProductButtonState(product, variant, requiresMeasurements, availableVariants, selectionUnavailable) {
    const anyAvailable = Array.isArray(availableVariants)
        ? availableVariants.length > 0
        : Boolean(product && Array.isArray(product.variants) && product.variants.some(function(item) { return item.available; }));

    // A size the shopper explicitly picked that is out of stock, and a product with
    // nothing in stock at all, both land on the notify CTA rather than a dead button.
    // selectionUnavailable (Item 15) is the third way in: every option row answered, but
    // that pairing is not a variant the merchant ever created. Same shopper intent, so
    // the same CTA rather than a button that does nothing.
    if (selectionUnavailable || (variant && !variant.available) || (!variant && !anyAvailable)) {
        return { notify: true, disabled: false, label: 'Sold out — Set Notifications' };
    }

    return {
        notify: false,
        disabled: !variant,
        label: getInteractiveProductButtonLabel(product, variant, requiresMeasurements)
    };
}

function getInteractiveProductButtonLabel(product, variant, requiresMeasurements) {
    const actionLabel = requiresMeasurements ? 'Place Order' : 'Add to Cart';
    const price = variant && variant.price ? variant.price : (product && product.price ? product.price : '');
    return price ? `${actionLabel} — ${price}` : actionLabel;
}

function buildInteractiveProductBlockHtml(point, blockIndex) {
    const product = point.product || null;
    const title = product ? product.title : point.description;
    const variants = product && Array.isArray(product.variants) ? product.variants : [];
    const requiresMeasurements = Boolean(product && product.requiresMeasurements);
    const hasOnlyDefaultVariant = variants.length === 1 && variants[0].title === 'Default Title';
    // Item 15: one row per option instead of one button per variant. The section has
    // always embedded product.options (options_with_values) in the point JSON; nothing
    // read it until now.
    const optionsApi = getInteractiveVariantOptionsApi();
    const productOptions = optionsApi ? optionsApi.options(product) : [];
    if (!optionsApi && variants.length) {
        // Without the resolver there is nothing to pick a size with, so say so rather than
        // rendering a silently size-less drawer.
        console.error('[high-thread] high-thread-variant-options.js did not load; size selection is unavailable.');
    }
    const availableVariants = variants.filter(function(variant) { return variant.available; });
    const autoVariant = requiresMeasurements
        ? (availableVariants.length ? availableVariants[0] : null)
        : (hasOnlyDefaultVariant && availableVariants.length ? availableVariants[0] : null);
    const buttonState = getInteractiveProductButtonState(product, autoVariant, requiresMeasurements, availableVariants);
    const detailsContent = renderDrawerRichText(
        product && product.descriptionHtml,
        product && product.description,
        'Product details will appear here once this point is connected to a product.'
    );
    const careContent = renderDrawerRichText(
        product && product.careHtml,
        product && product.care,
        'Care instructions have not been added for this product yet.'
    );

    return `
        <div class="interactive-product-drawer__product-block" data-interactive-product-block data-block-index="${blockIndex}" data-point-id="${point.id}">
            <div class="interactive-product-drawer__media" aria-label="Product imagery">
                ${buildInteractiveProductMedia(product, title)}
            </div>
            <div class="interactive-product-drawer__body" data-interactive-body>
                <button type="button" class="interactive-product-drawer__collapse-close" data-interactive-collapse-close aria-label="Collapse details">×</button>
                <h2 class="interactive-product-drawer__title">${escapeHtml(title)}</h2>
                <button type="button" class="interactive-product-drawer__see-details" data-interactive-see-details>See Details</button>
                <div class="interactive-product-drawer__body-content" data-interactive-body-content>
                    <div class="interactive-product-drawer__tabs" role="tablist" aria-label="Product information">
                        <button type="button" class="interactive-product-drawer__tab active" data-interactive-tab="details" role="tab" aria-selected="true">Details</button>
                        <button type="button" class="interactive-product-drawer__tab" data-interactive-tab="care" role="tab" aria-selected="false">Care</button>
                    </div>
                    <div class="interactive-product-drawer__tab-panel active" data-interactive-tab-panel="details">${detailsContent}</div>
                    <div class="interactive-product-drawer__tab-panel" data-interactive-tab-panel="care">${careContent}</div>
                    ${requiresMeasurements ? `<p class="interactive-product-drawer__made-to-order">This piece is made to order. Please enter your custom measurements below.</p>` : ''}
                    ${/* DO NOT ADD AN AVAILABILITY TERM TO THIS CONDITION. The row must
                          render when the product is FULLY SOLD OUT -- that is the whole
                          point of it, not an oversight.

                          Client correction #6: "cannot click on individual sold out
                          sizes... this should be clickable and change the cart button to
                          'sold out - set notifications'." A shopper on a sold-out piece
                          picks the size they are waiting for, and that size is what gets
                          preselected in the Set Notifications modal. Remove the row and
                          there is no way to say WHICH size you want -- while the modal
                          still asks for one, so the drawer and the modal contradict each
                          other.

                          This was added as `availableVariants.length &&` on 2026-08-12 and
                          reverted the same day. The report it was meant to fix -- "sizes
                          show as sold out on web, mobile is fine" -- had already been
                          retested and withdrawn before it shipped, and adding it caused the
                          client's next complaint: with four of seven products at zero
                          stock, four drawers lost their sizes at once and read as broken.
                          Verified since with Shopify's own uncached /cart/add.js that the
                          storefront's availability is correct in both directions, so there
                          was never a display bug to fix here. */
                      productOptions.length && variants.length && !hasOnlyDefaultVariant && !requiresMeasurements ? `
                        <div class="interactive-product-drawer__variants" data-interactive-variant-list>
                            ${productOptions.map(function(productOption, optionIndex) {
                                const optionName = optionsApi.heading(productOption.name);
                                /* Each row is its own radiogroup, named by its option. Before Item 15
                                   every button carried the whole combination ("8 / 10"), so the row it
                                   belonged to did not need saying; a row of bare "8"s does. The visible
                                   heading is hidden from the name so it is not read twice. Matches The
                                   Find, which already renders its option rows this way. */
                                return `
                                <div class="interactive-product-drawer__option" data-interactive-option data-option-index="${optionIndex}" role="radiogroup" aria-label="${escapeHtml(optionName)}">
                                    <span class="interactive-product-drawer__label" aria-hidden="true">${escapeHtml(optionName)}:</span>
                                    ${productOption.values.map(function(value) {
                                        return `<button type="button" class="interactive-product-drawer__variant" data-option-index="${optionIndex}" data-option-value="${escapeHtml(value)}" role="radio" aria-checked="false">${escapeHtml(value)}</button>`;
                                    }).join('')}
                                </div>`;
                            }).join('')}
                        </div>
                    ` : ''}
                    ${buildMeasurementFields(product)}
                    ${variants.length ? `
                        <button type="button" class="interactive-product-drawer__add" data-interactive-add-to-cart ${autoVariant ? `data-selected-variant-id="${autoVariant.id}"` : ''}${buttonState.notify ? ' data-interactive-set-notification' : ''} ${buttonState.notify ? '' : (autoVariant && !requiresMeasurements ? '' : 'disabled')}>
                            ${escapeHtml(buttonState.label)}
                        </button>
                    ` : ''}
                </div>
            </div>
        </div>
    `;
}

let activeDrawerPoint = null;
let activeDrawerExpanded = false;

function getActiveDrawerContext() {
    const point = activeDrawerPoint;
    const product = point ? point.product || null : null;
    const variants = product && Array.isArray(product.variants) ? product.variants : [];
    const requiresMeasurements = Boolean(product && product.requiresMeasurements);
    const availableVariants = variants.filter(function(variant) { return variant.available; });
    return { point: point, product: product, variants: variants, requiresMeasurements: requiresMeasurements, availableVariants: availableVariants };
}

/* Item 15 helpers. The option rows are the shopper-facing control, but every existing
   consumer in this file -- the /cart/add.js POST, the notify payload, the failure-path
   price -- reads addButton.dataset.selectedVariantId. So the rows are resolved down to
   that one id here and it stays the single source of truth. */
function getInteractiveVariantOptionsApi() {
    return window.HighThreadVariantOptions || null;
}

function getInteractiveSelectedOptionValues(content) {
    return Array.prototype.map.call(content.querySelectorAll('[data-interactive-option]'), function(group) {
        const selected = group.querySelector('[data-option-value].selected');
        return selected ? selected.dataset.optionValue || '' : '';
    });
}

/* Dims the values that cannot lead to an available variant and returns what the current
   selection resolves to. Availability is NOT the `disabled` attribute: client correction
   #6 removed it because it swallows the click, and a sold-out size has to stay clickable
   so it can open Set Notifications. */
function syncInteractiveOptionButtons(content, context) {
    const groups = content.querySelectorAll('[data-interactive-option]');
    const api = getInteractiveVariantOptionsApi();
    if (!groups.length || !api) return null;

    const values = getInteractiveSelectedOptionValues(content);

    Array.prototype.forEach.call(groups, function(group, optionIndex) {
        group.querySelectorAll('[data-option-value]').forEach(function(button) {
            const value = button.dataset.optionValue || '';
            const available = api.isValueAvailable(context.product, values, optionIndex, value);
            button.classList.toggle('is-unavailable', !available);
            button.setAttribute('data-variant-available', available ? 'true' : 'false');
            // Both states were carried by a class alone, which reaches nobody using a
            // screen reader. Deliberately NOT aria-disabled for the sold-out case: the
            // button is still actionable, because correction #6 requires a sold-out size
            // to open Set Notifications. The suffix is the same wording The Find puts in
            // its visible label.
            button.setAttribute('aria-checked', button.classList.contains('selected') ? 'true' : 'false');
            if (available) {
                button.removeAttribute('aria-label');
            } else {
                button.setAttribute('aria-label', value + ' — Sold out');
            }
        });
    });

    const complete = api.isComplete(context.product, values);
    return {
        values: values,
        complete: complete,
        variant: complete ? api.findVariant(context.product, values) : null
    };
}

function updateInteractiveAddButtonState(content) {
    const context = getActiveDrawerContext();
    const addButton = content.querySelector('[data-interactive-add-to-cart]');
    if (!addButton) return;

    // Null when the product has no option rows at all (default variant, made to order):
    // those keep the variant id seeded at render, exactly as before.
    const optionState = syncInteractiveOptionButtons(content, context);

    if (optionState) {
        addButton.dataset.selectedVariantId = optionState.variant ? String(optionState.variant.id) : '';
    }

    const selectedVariant = context.variants.find(function(variant) {
        return String(variant.id) === String(addButton.dataset.selectedVariantId || '');
    }) || null;
    const selectionUnavailable = Boolean(optionState && optionState.complete && !optionState.variant);
    const state = getInteractiveProductButtonState(context.product, selectedVariant, context.requiresMeasurements, context.availableVariants, selectionUnavailable);

    addButton.textContent = state.label;

    if (state.notify) {
        addButton.setAttribute('data-interactive-set-notification', '');
        addButton.disabled = false;
        return;
    }

    addButton.removeAttribute('data-interactive-set-notification');
    const measurementInputs = content.querySelectorAll('[data-measurement-key]');
    const measurementsComplete = Array.prototype.every.call(measurementInputs, function(input) {
        return input.value.trim().length > 0;
    });
    addButton.disabled = !addButton.dataset.selectedVariantId || !measurementsComplete;
}

/* STOCK IS A SNAPSHOT OF THE PAGE RENDER, SO RE-ASK FOR IT WHEN THE DRAWER OPENS.

   Everything above reads point.product, which sections/interactive-environment-1.liquid
   printed into the HTML and which this file parses exactly once, at load, into `points`.
   Nothing ever re-reads it. So the sizes in this drawer are as old as the document -- and
   the document can be very old:

     - "/" is served from Shopify's full-page cache, and an unknown query string does not
       bust it, so there is nothing the client can do to force a fresh render.
     - That cache is split into independent entries keyed off the browser's wallet
       capability -- Chrome/Edge, Safari (macOS and iOS share one) and Firefox are three
       different cached renders that expire independently. THAT is how "sold out on web,
       correct on mobile" happens. It is not a difference between this file and the mobile
       section: that section is the same kind of snapshot taken from the same document,
       and its only network call is /cart/add.js, exactly like this one.
     - A tab left open across an inventory edit never re-renders at all.

   /products/<handle>.js is itself page-cached, so this is not a hard real-time guarantee
   -- only checkout is. What it does guarantee is that the drawer is never older than the
   moment it was opened, which removes the entire "the page I loaded an hour ago" class of
   complaint that produced this report. */
function applyLiveInteractiveAvailability(product, live) {
    if (!product || !live || !Array.isArray(live.variants)) return false;

    const liveAvailability = {};
    live.variants.forEach(function(variant) {
        if (variant && variant.id != null) liveAvailability[String(variant.id)] = Boolean(variant.available);
    });

    let changed = false;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    variants.forEach(function(variant) {
        if (!variant || variant.id == null) return;
        const key = String(variant.id);
        // A variant deleted since the render keeps whatever it had. Dropping it to false
        // would grey out a size for a reason the shopper cannot see, and its button was
        // built from the render either way.
        if (!Object.prototype.hasOwnProperty.call(liveAvailability, key)) return;
        if (Boolean(variant.available) === liveAvailability[key]) return;
        variant.available = liveAvailability[key];
        changed = true;
    });

    if (typeof live.available === 'boolean' && product.available !== live.available) {
        product.available = live.available;
        changed = true;
    }

    return changed;
}

/* Products with no option rows had their variant id seeded at render time from the first
   AVAILABLE variant. If availability has moved, that seed has to move with it -- otherwise
   a single-variant or made-to-measure product that just came back in stock loses its
   "Sold out" CTA and gets a live "Add to Cart" with no variant behind it, which is
   permanently disabled. The two conditions below are the same two that seeded it. */
function reseedInteractiveDefaultVariant(content, context) {
    if (content.querySelector('[data-interactive-option]')) return;

    const hasOnlyDefaultVariant = context.variants.length === 1
        && context.variants[0]
        && context.variants[0].title === 'Default Title';
    if (!context.requiresMeasurements && !hasOnlyDefaultVariant) return;

    const addButton = content.querySelector('[data-interactive-add-to-cart]');
    if (!addButton) return;

    const current = context.variants.filter(function(variant) {
        return String(variant.id) === String(addButton.dataset.selectedVariantId || '');
    })[0];
    if (current && current.available) return;

    const next = context.availableVariants[0];
    if (next) {
        addButton.dataset.selectedVariantId = String(next.id);
    } else {
        delete addButton.dataset.selectedVariantId;
    }
}

function refreshInteractivePointStock(point) {
    const product = point && point.product;
    if (!product || !product.handle) return;
    if (!Array.isArray(product.variants) || !product.variants.length) return;

    fetch('/products/' + encodeURIComponent(product.handle) + '.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
    })
        .then(function(response) { return response.ok ? response.json() : null; })
        .then(function(live) {
            if (!applyLiveInteractiveAvailability(product, live)) return;
            // The shopper may have moved to another point while this was in flight. The
            // mutation above still stands and is used when they come back to this one.
            if (activeDrawerPoint !== point) return;

            const drawer = document.getElementById('interactive-product-drawer');
            const content = drawer ? drawer.querySelector('[data-interactive-product-content]') : null;
            if (!content || !drawer.classList.contains('open')) return;

            /* Always an in-place sync, never an innerHTML rebuild.

               This used to branch: whether the size rows exist at all depended on
               availability, so a refresh that crossed zero had to re-render. That
               availability term is gone (see buildInteractiveProductBlockHtml -- the rows
               must render for a sold-out product, per client correction #6), so the rows
               are present or absent for reasons that never change mid-session, and the
               branch could only ever fire spuriously and destroy the shopper's state.

               syncInteractiveOptionButtons recomputes is-unavailable on every button from
               the mutated product, so dimming still updates. A rewrite would throw away
               the chosen size and any typed measurements to correct a dimmed state the
               shopper may not even be looking at. */
            reseedInteractiveDefaultVariant(content, getActiveDrawerContext());
            updateInteractiveAddButtonState(content);
        })
        .catch(function() {
            /* Offline, a 404 because the product was unpublished, or a blip. Keep the
               rendered snapshot: a drawer showing last-render stock is strictly better
               than one that greys out every size because a fetch failed. */
        });
}

function bindInteractiveDrawerEvents(content) {
    if (content.dataset.interactiveDrawerBound === 'true') return;
    content.dataset.interactiveDrawerBound = 'true';

    content.addEventListener('input', function(event) {
        if (event.target.matches('[data-measurement-key]')) {
            updateInteractiveAddButtonState(content);
        }
    });

    content.addEventListener('click', function(event) {
        const context = getActiveDrawerContext();

        const seeDetails = event.target.closest('[data-interactive-see-details]');
        if (seeDetails) {
            activeDrawerExpanded = true;
            const body = content.querySelector('[data-interactive-body]');
            if (body) body.classList.add('is-expanded');
            return;
        }

        const collapseClose = event.target.closest('[data-interactive-collapse-close]');
        if (collapseClose) {
            activeDrawerExpanded = false;
            const body = content.querySelector('[data-interactive-body]');
            if (body) body.classList.remove('is-expanded');
            return;
        }

        const tab = event.target.closest('[data-interactive-tab]');
        if (tab) {
            const tabName = tab.dataset.interactiveTab;
            content.querySelectorAll('[data-interactive-tab]').forEach(function(item) {
                item.classList.toggle('active', item === tab);
                item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
            });
            content.querySelectorAll('[data-interactive-tab-panel]').forEach(function(panel) {
                panel.classList.toggle('active', panel.dataset.interactiveTabPanel === tabName);
            });
            return;
        }

        // Item 15: selection is per option row now, so only the clicked row is cleared.
        // updateInteractiveAddButtonState resolves the rows to the variant id.
        const optionButton = event.target.closest('[data-option-value]');
        if (optionButton) {
            const group = optionButton.closest('[data-interactive-option]');
            if (group) {
                group.querySelectorAll('[data-option-value]').forEach(function(item) { item.classList.remove('selected'); });
            }
            optionButton.classList.add('selected');
            updateInteractiveAddButtonState(content);
            return;
        }

        const notifyButton = event.target.closest('[data-interactive-set-notification]');
        if (notifyButton) {
            const notifyAddButton = content.querySelector('[data-interactive-add-to-cart]');
            const notifyVariantId = notifyButton.dataset.selectedVariantId
                || (notifyAddButton && notifyAddButton.dataset.selectedVariantId)
                || '';
            // A part-answered or non-existent combination has no variant id to pass, so
            // hand over the option values instead and let the modal preselect what it can.
            openHighThreadNotificationModal(context.product, notifyVariantId || getInteractiveSelectedOptionValues(content));
            return;
        }

        const addButton = event.target.closest('[data-interactive-add-to-cart]');
        if (addButton && !addButton.hasAttribute('data-interactive-set-notification')) {
            const variantId = addButton.dataset.selectedVariantId;
            const measurementInputs = content.querySelectorAll('[data-measurement-key]');
            const measurementsComplete = Array.prototype.every.call(measurementInputs, function(input) {
                return input.value.trim().length > 0;
            });
            if (!variantId || !measurementsComplete) return;

            addButton.disabled = true;
            addButton.textContent = 'Adding...';

            const addPayload = { id: Number(variantId), quantity: 1 };
            if (measurementInputs.length) {
                const properties = {};
                measurementInputs.forEach(function(input) {
                    properties[input.dataset.measurementKey] = input.value.trim();
                });
                addPayload.properties = properties;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(addPayload)
            })
            .then(function(response) {
                if (!response.ok) throw new Error('Unable to add item');
                addButton.textContent = 'Added';
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                openCartBesideInteractiveProductDrawer();
            })
            .catch(function() {
                const selectedVariant = context.variants.find(function(variant) {
                    return String(variant.id) === String(addButton.dataset.selectedVariantId);
                });
                const selectedPrice = selectedVariant && selectedVariant.price ? selectedVariant.price : (context.product && context.product.price ? context.product.price : '');
                addButton.textContent = selectedPrice ? `Try Again — ${selectedPrice}` : 'Try Again';
                addButton.disabled = false;
            });
        }
    });
}

function openInteractiveProductDrawer(startPoint) {
    const drawer = document.getElementById('interactive-product-drawer');
    const overlay = document.getElementById('interactive-product-drawer-overlay');
    const content = drawer ? drawer.querySelector('[data-interactive-product-content]') : null;
    if (!drawer || !overlay || !content) return;

    activeDrawerPoint = startPoint;
    activeDrawerExpanded = false;

    content.innerHTML = buildInteractiveProductBlockHtml(startPoint, 0);
    content.scrollTop = 0;
    updateInteractiveAddButtonState(content);
    bindInteractiveDrawerEvents(content);
    // Fire-and-forget. The drawer is already correct as of the page render and opens
    // instantly; this only corrects it when that render was stale. See the long note on
    // refreshInteractivePointStock for why a render can be hours old.
    refreshInteractivePointStock(startPoint);

    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    syncInteractiveDrawerState();
    updateHighThreadNextProductButton();
}

/* Item 20: the "Next Product" button at the bottom right of the drawer.

   The order is NOT decided here. It arrives in [data-high-thread-product-order], which
   sections/interactive-environment-1.liquid renders from either the collection the
   merchant picked in "Next product order" or, failing that, the order of the Product
   Point blocks in the theme editor. See the comment on that script tag.

   It always wraps: the entry after the last one is the first. A product missing from the
   order falls to the first entry rather than dead-ending, so nothing is unreachable.
   An entry that has a point on this page swaps the drawer in place; one that does not
   (possible when the chosen collection holds products with no point) is navigated to. */
let highThreadProductOrder = null;

function getHighThreadProductOrder() {
    if (highThreadProductOrder) return highThreadProductOrder;
    highThreadProductOrder = [];

    const source = document.querySelector('[data-high-thread-product-order]');
    if (!source) return highThreadProductOrder;

    try {
        const parsed = JSON.parse(source.textContent);
        if (Array.isArray(parsed)) {
            highThreadProductOrder = parsed.filter(function(entry) {
                return entry && entry.handle;
            });
        }
    } catch (error) {
        // Reported rather than swallowed: a silent catch here would leave the button
        // permanently hidden with nothing in the console to explain why.
        console.error('[high-thread] Next Product: could not parse the product order.', error);
    }

    return highThreadProductOrder;
}

function getHighThreadNextProductEntry(currentHandle) {
    const order = getHighThreadProductOrder();
    if (order.length < 2) return null;

    let currentIndex = -1;
    for (let index = 0; index < order.length; index += 1) {
        if (order[index].handle === currentHandle) {
            currentIndex = index;
            break;
        }
    }

    const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % order.length;
    const nextEntry = order[nextIndex];
    if (!nextEntry || nextEntry.handle === currentHandle) return null;
    return nextEntry;
}

function findInteractivePointByHandle(handle) {
    for (let index = 0; index < points.length; index += 1) {
        const candidate = points[index];
        if (candidate && candidate.product && candidate.product.handle === handle) {
            return candidate;
        }
    }
    return null;
}

/* Held in a variable rather than looked up each time: this runs on every drawer open,
   and the element it points at is stable for the life of the page. It stays stable
   because the button is a direct child of #interactive-product-drawer and is never moved
   into [data-interactive-product-content] -- the subtree openInteractiveProductDrawer
   rebuilds by assigning innerHTML. That rebuild therefore cannot detach it, so the
   element identity and its click listener survive every product swap on their own. */
let highThreadNextButton = null;

function getHighThreadNextButton() {
    if (!highThreadNextButton) {
        highThreadNextButton = document.querySelector('[data-interactive-next-product]');
    }
    return highThreadNextButton;
}

function updateHighThreadNextProductButton() {
    const button = getHighThreadNextButton();
    if (!button) return;

    const currentHandle = activeDrawerPoint && activeDrawerPoint.product
        ? activeDrawerPoint.product.handle
        : '';
    const nextEntry = currentHandle ? getHighThreadNextProductEntry(currentHandle) : null;

    /* Client correction #2: the control sits in a strip of its own at the bottom of the
       panel, and on desktop .has-next-product is what shortens each image by that strip so
       the images still match the scrollport they snap into. Set here, in step with the
       control's own visibility, so a panel with nothing to go to next -- a one-product loop,
       or a point with no product wired up -- has no strip and keeps full-screen images
       rather than being shortened for a control that is not there. */
    const drawer = document.getElementById('interactive-product-drawer');
    if (drawer) {
        drawer.classList.toggle('has-next-product', Boolean(nextEntry));
    }

    if (!nextEntry) {
        button.hidden = true;
        button.removeAttribute('data-next-handle');
        button.removeAttribute('data-next-url');
        return;
    }

    button.hidden = false;
    button.dataset.nextHandle = nextEntry.handle;
    button.dataset.nextUrl = nextEntry.url || '';
    button.setAttribute('aria-label', button.textContent.trim() + ': ' + (nextEntry.title || nextEntry.handle));
}

/* Only Next Product announces. Opening the drawer by clicking a point is a deliberate
   click on that product and was silent before Item 20 too; the swap is the new thing,
   because the dialog stays open and only its contents change under you. */
function announceHighThreadDrawerProduct(point) {
    const status = document.querySelector('[data-interactive-next-status]');
    if (!status) return;
    status.textContent = point && point.product && point.product.title ? point.product.title : '';
}

function setupHighThreadNextProduct() {
    const button = getHighThreadNextButton();
    if (!button || button.dataset.highThreadReady === 'true') return;
    button.dataset.highThreadReady = 'true';

    button.addEventListener('click', function(event) {
        event.preventDefault();
        const handle = button.dataset.nextHandle;
        if (!handle) return;

        const point = findInteractivePointByHandle(handle);
        if (point) {
            openInteractiveProductDrawer(point);
            // Keeps focus on this button across the swap, so the next Tab continues from
            // here inside the aria-modal dialog and the button stays under the finger for
            // a second press. Since client correction #2 the button sits outside the
            // subtree openInteractiveProductDrawer rebuilds, so focus is no longer lost
            // in the first place -- this is now a guard, not a repair. Kept because
            // nothing in that call promises where focus ends up.
            button.focus();
            announceHighThreadDrawerProduct(point);
            return;
        }

        if (button.dataset.nextUrl) {
            window.location.href = button.dataset.nextUrl;
        }
    });
}

document.getElementById('interactive-product-drawer-overlay')?.addEventListener('click', closeHighThreadDrawers);
document.querySelector('.interactive-product-drawer__close')?.addEventListener('click', closeInteractiveProductDrawer);

/* Client feedback: "reducing from the web view to small screen has a glitch — if the
   product panel is open when you shrink the screen, it stays open over the mobile view
   and looks like a mistake." The desktop drawer has no mobile counterpart, so close it
   whenever the viewport crosses into the mobile breakpoint. 767px matches the
   @media (max-width: 767px) rules in interactive-environments.css. Also releases the
   body scroll lock, which otherwise left the mobile homepage unscrollable. */
(function () {
    if (!window.matchMedia) return;
    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var handleBreakpointChange = function (event) {
        if (!event.matches) return;
        var drawer = document.getElementById('interactive-product-drawer');
        if (drawer && drawer.classList.contains('open')) {
            closeInteractiveProductDrawer();
        }
    };
    if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleBreakpointChange);
    } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(handleBreakpointChange);
    }
})();

/* Drives .interactive-product-drawer.ht-resizing -- the closed-panel peek during a
   resize. The mechanism and why this one is not width-gated are documented on that rule
   in interactive-environments.css; the equivalent for the cart lives in
   sections/cart-drawer.liquid. orientationchange is included because on iOS it can fire
   without a matching `resize`. */
(function () {
    var drawer = document.getElementById('interactive-product-drawer');
    if (!drawer) return;
    var settleTimer = null;
    var suppressDuringResize = function () {
        drawer.classList.add('ht-resizing');
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
            settleTimer = null;
            drawer.classList.remove('ht-resizing');
        }, 200);
    };
    window.addEventListener('resize', suppressDuringResize);
    window.addEventListener('orientationchange', suppressDuringResize);
})();

document.querySelectorAll('[data-high-thread-notify-close]').forEach(function(button) {
    button.addEventListener('click', closeHighThreadNotificationModal);
});
document.querySelectorAll('[data-high-thread-notify-channel]').forEach(function(input) {
    input.addEventListener('change', updateNotificationChannelFields);
});
/* CAPTURE PHASE, ON document, AND THAT IS THE WHOLE POINT.

   The obvious binding -- addEventListener('submit') on the form, preventDefault, maybe
   stopPropagation -- DOES NOT WORK HERE, and fails in the worst possible way: the POST
   still happens, so the shopper still gets bounced, but the Klaviyo call has already
   fired, so they are now subscribed AND still see the bug.

   Shopify's hCaptcha provider (ce_storefront_forms_captcha_hcaptcha) binds its own
   listener to THIS FORM ELEMENT -- `i.addEventListener("submit", t => { t.preventDefault(),
   y() })` where y() calls the native submit -- and it never checks defaultPrevented. It
   also monkey-patches form.submit. stopPropagation() only stops an event reaching
   ANCESTORS; listeners already on the same element still run. So a form-level cancel
   cannot stop it.

   That binding is not hypothetical on this store: the bootstrap injects the provider on
   the first `focusin` inside the form, and a shopper cannot fill this modal in without
   focusing a field. By the time they press Save Notification, the form carries
   data-hcaptcha-bound="true".

   Capture on document runs before the event descends to the form, so it is upstream of
   hCaptcha's listener AND of the document-level bubble listener, and it does not depend on
   registration order -- which matters because hCaptcha binds asynchronously.

   WHEN TESTING: focus a field and wait for data-hcaptcha-bound="true" BEFORE submitting.
   Testing before hCaptcha binds takes a different branch and gives a false pass. */
document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || form.id !== 'HighThreadNotificationForm') return;
    const modal = document.getElementById('high-thread-notification-modal');
    if (!modal) return;
    syncHighThreadNotificationInputs();
    const title = modal.dataset.productTitle || 'this piece';
    const sizeSelection = getNotificationSizeSelection();

    /* ONE PATH FOR BOTH CHANNELS. They differ only in which identifier is collected and
       which Klaviyo list it lands in. Consent, validation and the in-place confirmation are
       shared, which is what stops the two drifting apart the way three copies of the
       number-capture modal once did.

       Cancelling is now unconditional. While this was a Shopify customer form only the
       WhatsApp branch cancelled, and email deliberately let the native POST through; there
       is nothing left to post to, and letting a submit escape would reload the page and
       lose the sign-up silently.

       If a required field is empty this listener never runs at all -- the browser blocks
       the submit first. The `invalid` handler below is what stops that looking like a dead
       button. */
    event.preventDefault();
    event.stopPropagation();
    clearHighThreadNotificationError();

    const channel = getNotificationChannel();

    const consentCheckbox = modal.querySelector('[data-high-thread-notify-consent-checkbox]');
    if (consentCheckbox && !consentCheckbox.checked) {
        showHighThreadNotificationError('Please tick the box to opt in.');
        return;
    }

    let identifier;
    if (channel === 'whatsapp') {
        const phone = getHighThreadNotificationPhoneE164();
        if (!phone || phone.error) {
            showHighThreadNotificationError(phone && phone.error ? phone.error : 'Please enter your mobile number.');
            return;
        }
        identifier = phone.e164;
    } else {
        const emailInput = modal.querySelector('[data-high-thread-notify-email]');
        identifier = emailInput ? String(emailInput.value || '').trim() : '';
        /* Checked here as well as by `required` and type="email". Native validation is
           bypassable, and a blank or malformed address would otherwise reach Klaviyo and
           come back as a 400 whose message means nothing to a shopper. */
        if (!identifier) {
            showHighThreadNotificationError('Please enter your email address.');
            return;
        }
        if (emailInput && !emailInput.checkValidity()) {
            showHighThreadNotificationError('Please enter a valid email address.');
            return;
        }
    }

    highThreadPushRestockToKlaviyo(channel, identifier, title, sizeSelection.label).then(function() {
        try {
            window.sessionStorage.setItem('highThreadNotifyProductTitle', title);
            window.sessionStorage.setItem('highThreadNotifyProductSize', sizeSelection.label || '');
        } catch (error) {}
        openHighThreadNotificationSuccessModal();
    }).catch(function(error) {
        showHighThreadNotificationError(
            error && error.message ? error.message : 'Something went wrong — please try again.'
        );
    });
}, true);

/* WITHOUT THIS, "SAVE NOTIFICATION" LOOKS LIKE A DEAD BUTTON.

   Several controls in this modal are `required`, and the browser blocks the submit before
   any handler runs when one is empty -- so the whole Klaviyo path above is never reached.
   Normally that is fine, because the browser shows its own "Please select one of these
   options" bubble. It cannot here: the size radios and the consent checkbox are
   appearance:none custom controls, and a bubble has nothing to anchor to, so the press
   produces no submission, no error, and no feedback at all.

   The trap is worst on a two-option product (a set with a Top row and a Skirt row): there
   are TWO required size groups, choosing one of them looks complete, and pressing Save
   then does nothing whatsoever.

   `invalid` does not bubble, hence capture on document. It fires once per invalid control,
   in document order, so the flag keeps the FIRST message -- the one nearest the top of the
   form and most likely the thing the shopper actually missed. */
let highThreadNotifyInvalidShown = false;
document.addEventListener('invalid', function(event) {
    const el = event.target;
    if (!el || !el.form || el.form.id !== 'HighThreadNotificationForm') return;

    // Suppress the native bubble in all cases -- where it can render at all it is styled
    // nothing like this modal, and it would sit alongside our own message.
    event.preventDefault();
    if (highThreadNotifyInvalidShown) return;
    highThreadNotifyInvalidShown = true;
    window.setTimeout(function() { highThreadNotifyInvalidShown = false; }, 0);

    let message = el.validationMessage || 'Please complete this field.';
    if (el.type === 'radio' && String(el.name).indexOf('notification_size') === 0) {
        message = 'Please choose a size.';
    } else if (el.matches('[data-high-thread-notify-consent-checkbox]')) {
        message = 'Please tick the box to opt in.';
    } else if (el.matches('[data-high-thread-notify-phone]')) {
        message = 'Please enter your mobile number.';
    } else if (el.matches('[data-high-thread-notify-email]')) {
        message = el.value ? 'Please enter a valid email address.' : 'Please enter your email address.';
    }
    showHighThreadNotificationError(message);

    // The modal scrolls on a phone, and the field at fault is often above the fold.
    const target = el.closest('fieldset, label, .high-thread-notification-modal__phone-row') || el;
    if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'nearest' });
    }
}, true);

/* The ?customer_posted=true check that used to live here is gone with the Shopify form.
   Neither channel navigates any more, so there is no round trip to come back from and no
   flag to read: both confirmations are painted in place by the submit handler. Leaving the
   check in would have been harmless but misleading -- it could never fire again. */
if (document.getElementById('high-thread-notification-modal')) {
    updateNotificationChannelFields();
}

document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        closeHighThreadNotificationModal();
        closeHighThreadDrawers();
    }
});

function setupHighThreadNavigation() {
    const nav = document.querySelector('[data-high-thread-nav]');
    if (!nav || nav.dataset.highThreadReady === 'true') return;
    nav.dataset.highThreadReady = 'true';

    const toggle = nav.querySelector('[data-high-thread-localization-toggle]');
    const popover = nav.querySelector('[data-high-thread-localization-popover]');
    const countrySelect = nav.querySelector('[data-high-thread-country-select]');
    const currencyDisplay = nav.querySelector('[data-high-thread-currency-display]');
    const bagTrigger = nav.querySelector('[data-high-thread-bag-trigger]');

    function closeLocalization() {
        if (!popover || !toggle) return;
        popover.classList.remove('open');
        popover.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
    }

    function openLocalization() {
        if (!popover || !toggle) return;
        popover.classList.add('open');
        popover.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
    }

    if (toggle && popover) {
        toggle.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (popover.classList.contains('open')) {
                closeLocalization();
            } else {
                openLocalization();
            }
        });

        popover.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    }

    if (countrySelect && currencyDisplay) {
        countrySelect.addEventListener('change', function() {
            const selectedOption = countrySelect.options[countrySelect.selectedIndex];
            if (selectedOption && selectedOption.dataset.currency) {
                currencyDisplay.textContent = selectedOption.dataset.currency;
            }
        });
    }

    if (bagTrigger) {
        bagTrigger.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            closeLocalization();
            if (typeof window.openCartDrawer === 'function') {
                window.openCartDrawer();
            } else {
                document.dispatchEvent(new CustomEvent('cart:open'));
            }
        });
    }

    /* Item 18: the nav's WhatsApp icon forwards to the floating prompt instead of opening
       the modal itself, so snippets/high-thread-whatsapp-modal.liquid keeps a single
       opener per page. Same pattern sections/high-thread-legal.liquid already uses. */
    const navWhatsAppTrigger = nav.querySelector('[data-high-thread-nav-whatsapp-trigger]');
    if (navWhatsAppTrigger) {
        navWhatsAppTrigger.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            closeLocalization();
            const promptButton = document.querySelector('[data-high-thread-whatsapp-prompt]');
            if (promptButton) promptButton.click();
        });
    }

    document.addEventListener('click', function(event) {
        if (popover && popover.classList.contains('open') && !nav.contains(event.target)) {
            closeLocalization();
        }
    });


    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeLocalization();
    });
}


/* setupHighThreadWhatsAppPrompt() moved to assets/high-thread-whatsapp-prompt.js.
   snippets/high-thread-whatsapp-modal.liquid loads that file itself, so the handler now
   reaches all three surfaces that render the modal instead of only the two that happen to
   load this one. Nothing here referenced it. */

function setupHighThreadAboutOverlay() {
    const trigger = document.querySelector('[data-high-thread-about-trigger]');
    const overlay = document.querySelector('[data-high-thread-about-overlay]');
    if (!trigger || !overlay || trigger.dataset.highThreadReady === 'true') return;
    trigger.dataset.highThreadReady = 'true';

    function openAbout() {
        overlay.classList.add('open');
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
    }

    function closeAbout() {
        overlay.classList.remove('open');
        overlay.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openAbout();
    });

    overlay.addEventListener('click', function(event) {
        const panel = overlay.querySelector('.high-thread-about-overlay__panel');
        if (panel && !panel.contains(event.target)) closeAbout();
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeAbout();
    });
}

setupHighThreadAboutOverlay();

setupHighThreadNavigation();

setupHighThreadNextProduct();

const container = document.querySelector('.environment-container');
  let mediaElement = document.getElementById('store-environment-img');
if (!mediaElement) {
    mediaElement = document.getElementById('store-environment-video');
}
  
  function positionPoints() {
    // ITEM 16: measure the painted picture, not the <img> box - see
    // getEnvironmentMediaRect. On any window narrower than the image's aspect ratio the
    // two are identical, so these numbers are unchanged there.
    const mediaRect = getEnvironmentMediaRect(mediaElement);
    const mediaWidth = mediaRect.width;
    const mediaHeight = mediaRect.height;
    
    points.forEach(point => {
        let interactivePoint = container.querySelector(`.interactive-point[data-id="${point.id}"]`);
        
        if (!interactivePoint) {
            interactivePoint = document.createElement('div');
            interactivePoint.dataset.id = point.id;
            container.appendChild(interactivePoint);
            interactivePoint.classList.add('interactive-point');
          
              if (point.isTransition) {
                interactivePoint.style.height = "0px";
                interactivePoint.style.width = "0px";
                interactivePoint.classList.add('transition-point');
                
                
                
                const nav = document.createElement('nav');
                nav.classList.add('environment-nav');
                const a = document.createElement('a');
                const span = document.createElement('span');
                const h3 = document.createElement('h3');
                
                if(point.makeBgTransparent){
                  a.style.backgroundColor = "transparent";
                }
                else{
                  a.style.backgroundColor = point.backgroundColor;
                }
                if(point.makeBorderTransparent){
                  a.style.borderColor = "transparent";
                }
                else{
                  a.style.borderColor = point.borderColor;
                }
                a.href = point.link;
                a.style.setProperty('--transition-width', point.transitionWidth + 'px');
                a.classList.add(point.direction == 'right' ? "next" : "prev")
                span.classList.add('icon-wrap');
                h3.textContent = point.description;
                h3.style.color = point.transitionWordColor;
                span.innerHTML = '<svg class="icon" width="20" height="20" viewBox="0 0 64 64"><use xlink:href="#arrow-' + point.direction + '-2"></svg>';
                a.appendChild(span);
                a.appendChild(h3);
                nav.appendChild(a);
                interactivePoint.appendChild(nav);
                const svgElement = span.querySelector('svg');
                if (svgElement) {
                    svgElement.style.fill = point.arrowColor;
                }
                
            } 
            else
            {
            interactivePoint.style.backgroundColor = point.ipColor;
            // Create a hit area
            const hitArea = document.createElement('div');
            hitArea.classList.add('hit-area');
            interactivePoint.appendChild(hitArea);
            
            const dialogBox = document.createElement('a');
            dialogBox.classList.add('dialog-box');
            dialogBox.href = point.link || '#';
            dialogBox.textContent = point.product && point.product.title ? point.product.title : point.description;
            dialogBox.style.color = point.dialogWordColor;
            dialogBox.style.backgroundColor = point.dialogBoxColor;
            dialogBox.style.setProperty('--dialog-pointer-color', point.dialogBoxColor);
            interactivePoint.appendChild(dialogBox);

            interactivePoint.setAttribute('role', 'button');
            interactivePoint.setAttribute('aria-label', 'Open ' + ((point.product && point.product.title) || point.description || 'product details'));
            interactivePoint.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                openInteractiveProductDrawer(point);
            });
            dialogBox.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                openInteractiveProductDrawer(point);
            });
            
            const pulseRing = document.createElement('div');
            pulseRing.classList.add('pulse-ring');
            pulseRing.dataset.id = point.id;
            pulseRing.style.borderColor = point.pulseRingColor
            interactivePoint.appendChild(pulseRing);
        }
        }
        interactivePoint.style.left = `${mediaRect.left + (point.x / 100) * mediaWidth}px`;
        interactivePoint.style.top = `${mediaRect.top + (point.y / 100) * mediaHeight}px`;
      if(!point.isTransition){
        // Update the position and size of the hit area
        const hitArea = interactivePoint.querySelector('.hit-area');
        hitArea.style.left = '50%';
        hitArea.style.top = '50%';
        const dialogBox = interactivePoint.querySelector('.dialog-box');
        
        
        // Adjust these values to align the tip of the dialog box with the interactive point
        const pointCenterX = (point.x / 100);
        const pointCenterY = (point.y / 100);
        const dialogLeft = pointCenterX - (dialogBox.offsetWidth / 2) + 7;
        const dialogTop = pointCenterY - dialogBox.offsetHeight + 18;  // 10px offset for the tip
        dialogBox.style.left = `${dialogLeft}px`;
        dialogBox.style.top = `${dialogTop}px`;
        // Update the position and size of the pulse ring
        const ringSize = Math.min(mediaWidth, mediaHeight) * 0.05;  // Adjust this value to change the size of the ring
        const ringOffset = ringSize / 2;
        const pulseRing = interactivePoint.querySelector('.pulse-ring');
        pulseRing.style.left = `50%`;
        pulseRing.style.top = `50%`;
        pulseRing.style.marginLeft = `-${ringOffset}px`;
        pulseRing.style.marginTop = `-${ringOffset}px`;
        pulseRing.style.width = `${ringSize}px`;
        pulseRing.style.height = `${ringSize}px`;
      }
        
    });
  
  if (mediaElement.tagName === 'IMG') {
    mediaElement.onload = positionPoints;
} else if (mediaElement.tagName === 'VIDEO') {
    mediaElement.onloadeddata = positionPoints;
}}
  
  window.addEventListener('resize', positionPoints);
  positionPoints(); 
//FOR MOBILE INTERACTIVE POINTS
document.addEventListener('DOMContentLoaded', function() {
    let isMobile = window.innerWidth < 768;
    function updateDialogVisibility() {
        document.querySelectorAll('.dialog-box').forEach(dialog => {
            if (isMobile) {
                dialog.style.display = 'none';
            } else {
                dialog.style.display = '';
            }
        });
    }
    function attachClickListeners() {
        document.querySelectorAll('.interactive-point').forEach(point => {
            if (!point.classList.contains('transition-point')) {
                point.removeEventListener('click', handlePointClick);
                point.addEventListener('click', handlePointClick);
            }
        });
    }
    function handlePointClick(event) {
        if (this.getAttribute('role') === 'button') {
            return;
        }
        if (isMobile) {
            event.preventDefault();
            updateDialogVisibility();
            let dialogBox = this.querySelector('.dialog-box');
            if (dialogBox) {
                dialogBox.style.display = 'block';
                event.stopPropagation();
            }
        }
    }
    function attachDialogClickListeners() {
        document.querySelectorAll('.dialog-box').forEach(dialogBox => {
            dialogBox.removeEventListener('click', handleDialogClick);
            dialogBox.addEventListener('click', handleDialogClick);
        });
    }
    function handleDialogClick(event) {
        if (isMobile) {
            event.stopPropagation();
        }
    }
    function attachOutsideClickListener() {
        document.removeEventListener('click', handleOutsideClick);
        document.addEventListener('click', handleOutsideClick);
    }
    function handleOutsideClick(event) {
        if (isMobile) {
            updateDialogVisibility();
        }
    }
    function updateEventListeners() {
        isMobile = window.innerWidth < 768;
        attachClickListeners();
        attachDialogClickListeners();
        attachOutsideClickListener();
    }
    window.addEventListener('resize', function() {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < 768;
        if (wasMobile !== isMobile) {
            updateEventListeners();
            updateDialogVisibility();
        }
    });
    updateEventListeners();
});
document.addEventListener('touchstart', function(e) {
    let navButton = e.target.closest('nav a');
    if (!navButton) {
        let activeButtons = document.querySelectorAll('nav a.active');
        activeButtons.forEach(function(btn) {
            btn.classList.remove('active');
        });
    }
});
 if (window.innerWidth <= 768) { 
document.addEventListener('click', function(e) {
    let navButton = e.target.closest('nav a');
    if (navButton) {
        if (navButton.classList.contains('active')) {
            return;
        } else {
            e.preventDefault();
            let activeButtons = document.querySelectorAll('nav a.active');
            activeButtons.forEach(function(btn) {
                btn.classList.remove('active');
            });
            navButton.classList.add('active');
        }
    } else {
        let activeButtons = document.querySelectorAll('nav a.active');
        activeButtons.forEach(function(btn) {
            btn.classList.remove('active');
        });
    }
});
}
let hasSwiped = false;
  var svgSwipe = document.querySelector('#Swipe-horizontal_1');
  if(svgSwipe){
  svgSwipe.addEventListener('animationend', function() {
      this.remove();
  });
    let timeoutId = setTimeout(function() {
      svgSwipe.classList.add('fade-out');
  }, 16000);
  window.addEventListener('touchstart', function() {
    if(!hasSwiped){
    svgSwipe.classList.add('fade-out');
    clearTimeout(timeoutId);  // cancel the automatic fade-out if the user touches the screen
    hasSwiped = true;
    }
});
}
  
}
  
function enableHorizontalScroll() {
    const container = document.querySelector('.environment-container');
    if (container) {
        container.style.overflowX = 'scroll'; // Enable horizontal scrolling
        
        const scrollAmount = (container.scrollWidth - container.clientWidth) / 2;
        container.scrollTo({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
}
window.addEventListener('load', enableHorizontalScroll);
window.addEventListener('resize', enableHorizontalScroll);
  
/* ITEM 16: the landing image is now `object-fit: contain`, so on a window wider than the
   image's aspect ratio the picture is painted narrower than its own <img> box and centred
   in it, with white either side. The box still spans the full container (`min-width: 100%`
   in interactive-environments.css, which is what keeps horizontal panning reachable on
   tall screens), so offsetWidth/offsetLeft now describe the box, NOT the picture.
   Everything overlaid on the image - interactive points, the logo, the swipe gesture - was
   measured against the box, so on a wide window it would sit off the garment by up to half
   the white margin. This returns the rect the picture is really painted into, expressed in
   .environment-container's coordinate space (the container is position: relative, so it is
   the offsetParent of both the image and the absolutely positioned overlays).
   It falls back to the box, i.e. exactly the old numbers, whenever the true size is not
   known: before the image has loaded, and for the video variant, which is object-fit:
   cover and unchanged. Mirrors `object-position: center` - if that ever changes, change
   the two offsets below with it. */
function getEnvironmentMediaRect(media) {
    if (!media) {
        return { left: 0, top: 0, width: 0, height: 0 };
    }
    const boxLeft = media.offsetLeft;
    const boxTop = media.offsetTop;
    const boxWidth = media.offsetWidth;
    const boxHeight = media.offsetHeight;
    const naturalWidth = media.tagName === 'IMG' ? media.naturalWidth : 0;
    const naturalHeight = media.tagName === 'IMG' ? media.naturalHeight : 0;
    if (!naturalWidth || !naturalHeight || !boxWidth || !boxHeight) {
        return { left: boxLeft, top: boxTop, width: boxWidth, height: boxHeight };
    }
    const scale = Math.min(boxWidth / naturalWidth, boxHeight / naturalHeight);
    const paintedWidth = naturalWidth * scale;
    const paintedHeight = naturalHeight * scale;
    return {
        left: boxLeft + (boxWidth - paintedWidth) / 2,
        top: boxTop + (boxHeight - paintedHeight) / 2,
        width: paintedWidth,
        height: paintedHeight
    };
}

function positionLogo() {
    const container = document.querySelector('.environment-container');
    const logo = document.getElementById('logo-container');
    const envImage = document.getElementById('store-environment-img');
    
    if (logo && envImage) {
        const mediaRect = getEnvironmentMediaRect(envImage);
        const totalWidth = mediaRect.width;
        const logoWidth = logo.offsetWidth;
        const centerPosition = mediaRect.left + (totalWidth - logoWidth) / 2;
        
        logo.style.left = `${centerPosition}px`;
        logo.style.right = 'auto';
        logo.style.transform = 'none';
        logo.style.margin = '0';
    }
}
function updateDimensions() {
    positionLogo(); 
}
window.addEventListener('load', positionLogo);
  
function positionSwipeGesture() {
    const container = document.querySelector('.environment-container');
    const swipeGesture = document.getElementById('Swipe-horizontal_1');
    const envImage = document.getElementById('store-environment-img');
    
    if (swipeGesture && envImage) {
        const mediaRect = getEnvironmentMediaRect(envImage);
        const totalWidth = mediaRect.width;
        const gestureWidth = 140; 
        const centerPosition = mediaRect.left + (totalWidth - gestureWidth) / 2;
        
        swipeGesture.style.left = `${centerPosition - 100}px`;
        swipeGesture.style.transform = 'none';
        swipeGesture.style.margin = '0';
    }
}
function updateDimensions() {
    positionLogo();
    positionSwipeGesture();
}
window.addEventListener('load', positionSwipeGesture);